export default __webpack_public_path__ + "static/media/Liam.0d462d70.jpg";